module.exports = __webpack_public_path__ + "img/progressbar.f6c7947d.png";